export const NAVIGATION_GUARD_EVENT = "app:navigation-guard-request";

export interface NavigationGuardDetail {
  proceed: () => void;
}

export const requestGuardedNavigation = (proceed: () => void) => {
  const event = new CustomEvent<NavigationGuardDetail>(NAVIGATION_GUARD_EVENT, {
    cancelable: true,
    detail: { proceed },
  });

  if (window.dispatchEvent(event)) proceed();
};
